import { Directive } from '@angular/core';

@Directive({
    selector: '[addBar]'
})
export class AddBarDirective {}


// WEBPACK FOOTER //
// C:/Users/Willi/Source/Repos/Reservation01/scr/reservation.client/src/app/directives/add-bar/add-bar.directive.ts